import React, { PropTypes } from 'react';
import { Button, Modal } from 'react-bootstrap';

class UsersOverviewAssignmentRemovalModal extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    render = () => {
        return (
            <Modal show={true} title={"Confirm assignment removal"}>
                <div className="modal-body">
                    Are you sure you want to remove all assignments on the project for the selected user ?
                    Clicking "yes" will instantly remove all of the assigned tasks for <b>{this.props.user.givenName + " " + this.props.user.surname + " "}</b>
                    on <b>{this.props.projectName}</b>
                </div>
                <div className="modal-footer">
                    <Button onClick={this.props.handleConfirmedDelete}>Yes</Button>
                    <Button onClick={this.props.handleToggleModal}>No</Button>
                </div>
            </Modal>
        );
    }
}

UsersOverviewAssignmentRemovalModal.propTypes = {
    handleConfirmedDelete: PropTypes.func,
    handleToggleModal: PropTypes.func,
    projectName: PropTypes.string,
    user: PropTypes.object
};

export default UsersOverviewAssignmentRemovalModal;



/** WEBPACK FOOTER **
 ** ./src/app/components/UsersOverviewAssignmentRemovalModal.js
 **/